import React from "react";
import Logo from "../../assets/images/logo-2.png";

const About = (props) => {
  return (
    <div id="about" className="py-6">
      <div className="container">
        <div className="row align-items-center gx-5"> 
          {/* Image Column - Fixed minimum width */}
          <div className="col-12 col-lg-6 mb-4 mb-lg-0"> {/* Responsive margin */}
            <div className="d-flex justify-content-center"> {/* Centered image container */}
              <img 
                src={Logo} 
                className="img-fluid" 
                alt="logo" 
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "contain"
                }}
              />
            </div>
          </div>

         
          <div className="col-12 col-lg-6">
            <div className="about-text">
              <h2 className="mb-4">Tentang BPPMHKP</h2> 
              <p className="lead mb-4"> 
                BPPMHKP adalah singkatan dari Badan Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan. 
                Badan ini merupakan otoritas kompeten di bawah Kementerian Kelautan dan Perikanan (KKP) yang bertugas 
                untuk menjamin mutu hasil kelautan dan perikanan melalui pengendalian dan pengawasan yang ketat, 
                mulai dari hulu hingga hilir.
              </p>
              
              <div className="row gx-1 gy-4"> 
                <div className="col-md-6">
                  <div className="h-100 p-3 border rounded"> 
                    <h3 className="h5 mb-3">Layanan Sertifikasi Produk Perikanan Pascapanen</h3>
                    <ul className="list-unstyled">
                      {props.data
                        ? props.data.Why.map((d, i) => (
                            <li key={`${d}-`} className="mb-2">
                              <i className="fas fa-check-circle text-primary me-2"></i>
                              {d}
                            </li>
                          ))
                        : <li>Loading...</li>}
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="h-100 p-3 border rounded"> 
                    <h3 className="h5 mb-3">Layanan Sertifikasi Produk Perikanan Primer</h3>
                    <ul className="list-unstyled">
                      {props.data
                        ? props.data.Why2.map((d, i) => (
                            <li key={`${d}-${i}`} className="mb-2">
                              <i className="fas fa-check-circle text-primary me-2"></i>
                              {d}
                            </li>
                          ))
                        : <li>Loading...</li>}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;